class comingSoon extends HTMLElement {
  constructor() {
    super();
    this.initiateCountDown();
  }

  initiateCountDown() {
    this.timerEl = this.querySelector('.timer');
    if (!this.dataset.time || this.dataset.time == '') return;
    
    this.countDownDate = new Date(this.dataset.time).getTime();
    const countDown = setInterval(() => {
      const now = new Date().getTime();

      const distance = this.countDownDate - now;

      const days =
        Math.floor(distance / (1000 * 60 * 60 * 24)) > 0 ? `${Math.floor(distance / (1000 * 60 * 60 * 24))}D<span class="time-spacer">:</span>` : '';
      const hours =
        Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) > 0
          ? `${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}H<span class="time-spacer">:</span>`
          : '';
      const minutes =
        Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) > 0
          ? `${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}M<span class="time-spacer">:</span>`
          : '';

      const seconds = `${Math.floor((distance % (1000 * 60)) / 1000)}S`;

      this.timerEl.innerHTML = `${days}${hours}${minutes}${seconds}`;

      if (distance < 0) {
        clearInterval(countDown);
        this.timerEl.innerHTML = '';
      }
    }, 1000);
  }
}

customElements.define('coming-soon', comingSoon);